module.exports = __webpack_public_path__ + "img/head-banner.22e02f05.jpg";